export const WIKI_URL = 'wiki'
export const WIKI_PAGE_URL = 'wiki-page'
